import { Field } from 'formik'
import React from 'react'
import { Link } from 'react-router-dom'

import { Input, Tooltip } from '@fourthwall/components'
import { routing } from '@utils/routing'

import { useMetaConversionPixel } from '../../../../../../Apps/pages/AppsMetaConversions'

export const FacebookPixelField = () => {
  const { pixelId, isLoading, error } = useMetaConversionPixel()

  if (isLoading) return <Input disabled />
  if (error) return <Input disabled label={error.message} />

  if (!pixelId)
    return (
      <Field
        component={Input}
        name="facebookPixelId"
        label="Facebook Pixel ID"
        suggestion={
          <div>
            We recommend using the Meta Conversions API. Set it up in the{' '}
            <Link to={routing.apps.metaCAPI}>Meta Ads App</Link>.
          </div>
        }
      />
    )

  return (
    <Tooltip
      offset={[0, 8]}
      placement="bottom-start"
      reference={
        <Input label="Facebook Pixel ID (Conversions API)" value={pixelId} type="text" disabled />
      }
    >
      <div>
        You are using the Meta Conversions API through the Meta Ads App. Your shop will use the
        pixel id set through that app.
      </div>
    </Tooltip>
  )
}
